import { CButton, CButtonGroup } from '@coreui/react-pro'
import { Button, DialogActions, DialogContent, DialogTitle } from '@mui/material'
import { useState } from 'react'
import { CustomInput, CustomSelect, selectTypes } from 'src/consumer/components/helperComponents'

export default function TeacherPayoutReportsFilters({
  finalFilters,
  clinicBrands,
  setFinalFilters,
  closeDialog,
}) {
  const [filters, setFilters] = useState(finalFilters)

  function finallySetFilters() {
    let fltr = { ...filters }
    if (fltr?.nonClinicalEvents === 'true') {
      fltr = { ...fltr, 'clinic-brand-id': null }
    }

    setFinalFilters(fltr)
  }

  return (
    <>
      <DialogTitle>Filters</DialogTitle>
      <DialogContent>
        <div className="d-flex flex-column gap-3">
          <div className="w-100" style={{ zIndex: 2 }}>
            <CustomInput
              id="patientNumber"
              label="Patient number"
              onChange={(e) =>
                setFilters((prev) => ({ ...prev, 'patient-number': e.target.value }))
              }
              value={filters?.['patient-number']}
              isClearable
              placeholder="Enter a patient number to search"
            />
          </div>
          <div className="mb-2" style={{  width: '100%' }}>
            <div>
              <CButtonGroup variant="outlined" size="sm">
                <CButton
                  color={'secondary'}
                  active={filters?.markedCompletedEvents === 'false'}
                  onClick={() =>
                    setFilters((prev) => ({ ...prev, markedCompletedEvents: 'false' }))
                  }
                >
                  Not Marked Completed Bookings
                </CButton>
                <CButton
                  color={'secondary'}
                  active={filters?.markedCompletedEvents === 'true'}
                  onClick={() => setFilters((prev) => ({ ...prev, markedCompletedEvents: 'true' }))}
                >
                  Marked Completed Bookings
                </CButton>
                <CButton
                  color={'secondary'}
                  active={
                    filters?.markedCompletedEvents === null ||
                    filters?.markedCompletedEvents === undefined
                  }
                  onClick={() => setFilters((prev) => ({ ...prev, markedCompletedEvents: null }))}
                >
                  All Bookings
                </CButton>
              </CButtonGroup>
            </div>
          </div>
          <div className="mb-2" style={{ maxWidth: '250px', width: '100%' }}>
            <div>
              <CButtonGroup variant="outlined" size="sm">
                <CButton
                  color={'secondary'}
                  active={filters?.nonClinicalEvents === 'false'}
                  onClick={() => setFilters((prev) => ({ ...prev, nonClinicalEvents: 'false' }))}
                >
                  Clinical Bookings
                </CButton>
                <CButton
                  color={'secondary'}
                  active={filters?.nonClinicalEvents === 'true'}
                  onClick={() => setFilters((prev) => ({ ...prev, nonClinicalEvents: 'true' }))}
                >
                  Non Clinical Bookings
                </CButton>
                <CButton
                  color={'secondary'}
                  active={
                    filters?.nonClinicalEvents === null || filters?.nonClinicalEvents === undefined
                  }
                  onClick={() => setFilters((prev) => ({ ...prev, nonClinicalEvents: null }))}
                >
                  All Bookings
                </CButton>
              </CButtonGroup>
            </div>
          </div>
          {filters?.nonClinicalEvents !== 'true' && (
            <div className="w-100" style={{ zIndex: 2 }}>
              <CustomSelect
                id="clinicBrand"
                options={clinicBrands}
                menuPortalTarget={document.body}
                styles={{ menuPortal: (base) => ({ ...base, zIndex: 9999 }) }}
                label="Clinic Brand"
                getOptionLabel={(optn) => optn?.title}
                getOptionValue={(optn) => optn?.id}
                selectType={selectTypes.string}
                onChangeEvent={(e) =>
                  setFilters((prev) => ({ ...prev, 'clinic-brand-id': e.target.value }))
                }
                value={filters?.['clinic-brand-id']}
                isClearable
                placeholder="Select a Clinic Brand"
              />
            </div>
          )}
        </div>
      </DialogContent>
      <DialogActions>
        <Button color="unFocused" onClick={closeDialog}>
          Cancel
        </Button>
        <Button
          onClick={() => {
            finallySetFilters()
            closeDialog()
          }}
          variant="contained"
        >
          Apply
        </Button>
      </DialogActions>
    </>
  )
}
